import { Component, Input } from '@angular/core';
import { ModalService } from '../../modal/modal.service';
import { Appointment } from './appointment';
import { AppointmentService } from './appointment.service';

@Component({
    selector: 'app-cancel-appointment',
    template: `<h4>Are you sure you want to cancel this appointment?</h4>
					<div class="dcf-pt-5">
						<button type="button" class="dcf-btn dcf-btn-secondary close-modal-button" (click)="closeCancelling()">No, do not Cancel</button>
						<button type="button" id="cancel-button" class="dcf-btn dcf-btn-primary" (click)="cancelAppointment()">Yes, cancel</button>
					</div>`,
    standalone: false
})
export class CancelAppointment {

  @Input() appointment!: any;

  cancelling = false;

  constructor(
    private modalService: ModalService,
    private appointmentService: AppointmentService
  ) {
    
  };

  closeCancelling() {
    this.modalService.close();
  }
 
  cancelAppointment() {
    if (this.cancelling) return;

    if (this.appointment.appointmentId === null) return;
    this.cancelling = true;

    const appointment = this.appointment as Appointment
    const appointmentId = appointment.appointmentId
    this.appointmentService.cancelAppointment(this.appointment.appointmentId).subscribe((result) => {
      if (result.success) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        appointment.cancelled = true;
        appointment.started = true;
        appointment.statusText = "Cancelled";

        // Let the user know it was successful
        // NotificationUtilities.giveNotice("Success!", "This appointment was successfully cancelled.", true);
      } else {
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        // Let the user know it failed
        // NotificationUtilities.giveNotice("Failure", "Something went wrong and this appointment was not cancelled!", false);
      }
      this.cancelling = false;
      this.closeCancelling();
    })
  }
}